import React from "react";
import ImgAbout from "../static/img/ha.gif";

import { Fade } from "react-reveal";

export default class End extends React.Component {
    render() {
        return (
            <Fade top duration={1000} distance="20px">


            <div className="container about-me remove-padding d-flex flex-column flex-lg-row">
                <div className="about-left-side m-4 col-lg-6 about-me-texts">
                    <img src={ImgAbout} alt="about-me" className="img-auto" />
                </div>
                <div className=" m-4">
                    <div className="about-me-texts">
                        <br></br>
                        <br></br>

                        <span className="txt-about"> Contact me </span>

                        <br></br>
                        <div className="text-end">

                  
                        <p >   <strong> Email : </strong> TAKOUA.CHAABANE@GMAIL.COM </p>
                        <p> <strong>  Linkedin : </strong> Takwa Chaabane </p>
                        <br></br>
                        
                        </div>
                       


                        <br></br>


                    </div>
                    {/*<div className="about-btn-container mt-5 d-flex flex-column flex-sm-row align-items-center">*/}
                    {/*<span className="btn-rounded m-2 col-6 text-center">hire me</span>*/}
                    {/*<span className="btn-none-rounded m-2 col-6 text-center">see my resume</span>*/}
                    {/*</div>*/}
                </div>
            </div>
            </Fade>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/End.js